import { Card, CardContent } from '@/components/ui/card'
import {
  IconCoins,
  IconTrendingUp,
  IconMoodSad,
  IconCurrencyPound,
} from '@tabler/icons-react'
import CTAButton from '@/components/shared/CTAButton'

export function MisSoldSigns({ className = '' }) {
  return (
    <section className={`w-full py-4 sm:py-6 ${className}`}>
      <div className="mx-auto max-w-6xl px-4">
        <h2 className="text-foreground mb-4 text-center text-4xl font-black sm:mb-6 sm:text-5xl">
          COMMON SIGNS OF MIS-SOLD CAR FINANCE
        </h2>

        <p className="text-foreground mb-6 text-center text-lg font-medium sm:mb-8 sm:text-xl">
          Thousands of drivers faced these unfair practices. Sound familiar? You
          may have been a victim of mis-sold vehicle finance.
        </p>

        <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-4 lg:gap-6">
          <Card className="border-foreground group rounded-2xl border-2 bg-white transition-all duration-300 hover:scale-105 hover:shadow-lg">
            <CardContent className="px-3 py-3 text-center">
              <div className="mb-1 flex justify-center">
                <IconCoins size={40} className="text-orange-400" />
              </div>
              <h3 className="text-foreground mb-1 text-lg font-bold">
                Hidden Commissions
              </h3>
              <p className="text-foreground text-base leading-relaxed">
                Were you kept in the dark about commission?
              </p>
            </CardContent>
          </Card>

          <Card className="border-foreground group rounded-2xl border-2 bg-white transition-all duration-300 hover:scale-105 hover:shadow-lg">
            <CardContent className="px-3 py-3 text-center">
              <div className="mb-1 flex justify-center">
                <IconTrendingUp size={40} className="text-orange-400" />
              </div>
              <h3 className="text-foreground mb-1 text-lg font-bold">
                Interest Rate Changes
              </h3>
              <p className="text-foreground text-base leading-relaxed">
                Were rates modified without your knowledge?
              </p>
            </CardContent>
          </Card>

          <Card className="border-foreground group rounded-2xl border-2 bg-white transition-all duration-300 hover:scale-105 hover:shadow-lg">
            <CardContent className="px-3 py-3 text-center">
              <div className="mb-1 flex justify-center">
                <IconMoodSad size={40} className="text-orange-400" />
              </div>
              <h3 className="text-foreground mb-1 text-lg font-bold">
                Sales Pressure
              </h3>
              <p className="text-foreground text-base leading-relaxed">
                You were pushed into signing the agreement.
              </p>
            </CardContent>
          </Card>

          <Card className="border-foreground group rounded-2xl border-2 bg-white transition-all duration-300 hover:scale-105 hover:shadow-lg">
            <CardContent className="px-3 py-3 text-center">
              <div className="mb-1 flex justify-center">
                <IconCurrencyPound size={40} className="text-orange-400" />
              </div>
              <h3 className="text-foreground mb-1 text-lg font-bold">
                Unclear Costs
              </h3>
              <p className="text-foreground text-base leading-relaxed">
                Additional fees weren&apos;t properly disclosed to you.
              </p>
            </CardContent>
          </Card>
        </div>

        <div className="mt-6 text-center">
          <CTAButton />
        </div>
      </div>
    </section>
  )
}

export default MisSoldSigns
